import {ConditionType} from "../../../../model2/conditions/condition-types"
import {defaultMomentConditionValue} from "../../../generic/datetime/moment/render/condition-value"

// The composite value of the "status changed" condition.
// fromValues / toValues empty = "Any status".
export type StatusChangedConditionValue = {
    fromValues  : ID[]
    toValues    : ID[]
    dateType    : ConditionType
    dateValue   : any
}

// Fills every missing part of the value with the default the form actually renders, so what the
// user sees is what the backend gets. The form materializes the result into the Condition:
// without it a condition the user never touched keeps an undefined value, Condition.isEmpty is
// true and the whole condition is dropped from the payload.
//
// The enum is read inside the function, never at module scope - a module-scope read can still be
// undefined while the circular import that loads the field modules is resolving.
export function fillStatusChangedConditionValue(value: any): StatusChangedConditionValue {
    const dateType = value?.dateType || ConditionType.DATE_RELATIVE_PERIOD

    return {
        fromValues  : value?.fromValues || [],
        toValues    : value?.toValues || [],
        dateType,
        dateValue   : _.isNil(value?.dateValue) ? defaultMomentConditionValue(dateType) : value.dateValue,
    }
}
